import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  addGlossaryItemResponseSchema,
  addGlossaryItemV1PayloadSchema,
  addGlossaryItemV2PayloadSchema,
  BulkGlossaryAliasesUpdatePayloadSchema,
  BulkGlossaryAliasesUpdateResponseSchema,
  glossaryListResponseSchema,
  glossaryV1QuerySchema,
  glossaryV2QuerySchema,
  type GlossaryListQueryResult,
} from './schemas.js';

export * from './schemas.js';

export const getGlossaryListQueryOptions = defaultClient.query({
  url: 'data-ingestion/glossaries/' as const,
  method: 'GET',
  querySchema: glossaryV1QuerySchema,
  responseSchema: glossaryListResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data): GlossaryListQueryResult {
    return data.data;
  },
  keyPrefix: ['glossaryList'],
});

export const getGlossaryListV2QueryOptions = defaultClient.query({
  url: 'data-ingestion/glossaries/v2/' as const,
  method: 'GET',
  querySchema: glossaryV2QuerySchema,
  responseSchema: glossaryListResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data): GlossaryListQueryResult {
    return data.data;
  },
  keyPrefix: ['glossaryList'],
});

export const addGlossaryItem = defaultApi.declareEndpoint({
  url: 'data-ingestion/glossaries/' as const,
  method: 'POST',
  requestSchema: addGlossaryItemV1PayloadSchema,
  responseSchema: addGlossaryItemResponseSchema,
});

export const addGlossaryItemV2 = defaultApi.declareEndpoint({
  url: 'data-ingestion/glossaries/v2/' as const,
  method: 'POST',
  requestSchema: addGlossaryItemV2PayloadSchema,
  responseSchema: addGlossaryItemResponseSchema,
});

export const bulkGlossaryAliasesUpdate = defaultApi.declareEndpoint({
  url: 'data-ingestion/glossaries/$glossaryId/batch-codes/' as const,
  method: 'POST',
  requestSchema: BulkGlossaryAliasesUpdatePayloadSchema,
  responseSchema: z.object({
    data: z.object({
      items: BulkGlossaryAliasesUpdateResponseSchema,
    }),
  }),
});

export const bulkGlossaryAliasesUpdateV2 = defaultApi.declareEndpoint({
  url: 'data-ingestion/glossaries/$glossaryId/batch-codes/v2/' as const,
  method: 'POST',
  requestSchema: BulkGlossaryAliasesUpdatePayloadSchema,
  responseSchema: z.object({
    data: z.object({
      items: BulkGlossaryAliasesUpdateResponseSchema,
    }),
  }),
});
